/**
 * PdfFrame — Batch #14.244
 * Aperçu PDF intégré sur desktop ; sur téléphone/tablette (iOS n'affiche que la 1re page
 * d'un PDF dans une iframe, sans défilement), on propose plutôt un bouton d'ouverture.
 */
import { ExternalLink, FileText } from "lucide-react";

export const isMobileOrIOS = () => {
  if (typeof window === "undefined") return false;
  const nav = window.navigator;
  const ua = nav.userAgent || "";
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isIPadOS = nav.platform === "MacIntel" && nav.maxTouchPoints > 1;
  const isAndroid = /Android/.test(ua);
  return isIOS || isIPadOS || isAndroid;
};

export default function PdfFrame({ src, openUrl, filename = "document.pdf", title, height = "70vh", testId, accent = "#072354", label = "Ouvrir le document (PDF)" }) {
  if (isMobileOrIOS()) {
    // CR-001 : Safari iOS refuse d'ouvrir une URL blob: dans un nouvel onglet → on privilégie
    // l'URL serveur (openUrl) ; sinon repli sur un téléchargement du blob (aperçu natif iOS).
    const href = openUrl || src;
    const isBlob = typeof href === "string" && href.startsWith("blob:");
    const linkProps = isBlob ? { download: filename } : { target: "_blank", rel: "noopener noreferrer" };
    return (
      <div className="p-6 text-center bg-slate-50 space-y-3" data-testid={`${testId}-mobile`}>
        <FileText className="w-10 h-10 mx-auto text-slate-300" />
        <p className="text-sm text-slate-600">
          {isBlob ? "Sur téléphone, le document se télécharge pour une lecture complète." : "Sur téléphone, le document s'ouvre dans un nouvel onglet pour une lecture complète."}
        </p>
        <a href={href} {...linkProps}
          className="inline-flex items-center justify-center gap-2 w-full px-4 py-3 rounded-xl text-white text-sm font-bold"
          style={{ background: accent }} data-testid={`${testId}-open`}>
          <ExternalLink className="w-4 h-4" /> {label}
        </a>
        <p className="text-[11px] text-slate-400">Revenez ensuite sur cet onglet pour continuer.</p>
      </div>
    );
  }
  return <iframe title={title} src={src} className="w-full" style={{ height, border: 0 }} data-testid={testId} />;
}
